import React from 'react';

import type { ReferencesDict } from '@/api/mutations/useCreateManualThread';

interface CitationListProps {
  citationNumbers: string[];
  references: ReferencesDict;
  selectedCitation: string | null;
  onSelectCitation: (citationNum: string) => void;
  onRemoveReference: (citationNum: string) => void;
}

const CitationList: React.FC<CitationListProps> = ({
  citationNumbers,
  references,
  selectedCitation,
  onSelectCitation,
  onRemoveReference,
}) => {
  if (citationNumbers.length === 0) {
    return (
      <div className="text-center text-sm text-gray-500">
        No citations in answer. Use &quot;Add Citation&quot; button to insert citations.
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {citationNumbers.map((num) => {
        const ref = references[num];
        const isAssigned = !!ref;
        const isSelected = selectedCitation === num;

        return (
          <button
            key={num}
            onClick={() => onSelectCitation(num)}
            className={`flex h-8 min-w-[2rem] items-center justify-center rounded px-2 text-sm font-semibold transition-all ${
              isSelected ? 'ring-2 ring-blue-500 ring-offset-1' : ''
            } ${
              isAssigned ? 'bg-green-100 text-green-800 hover:bg-green-200' : 'bg-red-100 text-red-800 hover:bg-red-200'
            }`}
          >
            [{num}]
          </button>
        );
      })}
    </div>
  );
};

export default CitationList;
